var _circle, _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAvatarImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13591_6448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13591_6448)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13591_6448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    stroke: "#D2D1CE",
    strokeWidth: 4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6967 35.1967C20.1032 33.7902 22.0109 33 24 33H36C37.9891 33 39.8968 33.7902 41.3033 35.1967C42.7098 36.6032 43.5 38.5109 43.5 40.5V43.5C43.5 44.3284 42.8284 45 42 45C41.1716 45 40.5 44.3284 40.5 43.5V40.5C40.5 39.3065 40.0259 38.1619 39.182 37.318C38.3381 36.4741 37.1935 36 36 36H24C22.8065 36 21.6619 36.4741 20.818 37.318C19.9741 38.1619 19.5 39.3065 19.5 40.5V43.5C19.5 44.3284 18.8284 45 18 45C17.1716 45 16.5 44.3284 16.5 43.5V40.5C16.5 38.5109 17.2902 36.6032 18.6967 35.1967Z",
    fill: "#D2D1CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18C27.5147 18 25.5 20.0147 25.5 22.5C25.5 24.9853 27.5147 27 30 27C32.4853 27 34.5 24.9853 34.5 22.5C34.5 20.0147 32.4853 18 30 18ZM22.5 22.5C22.5 18.3579 25.8579 15 30 15C34.1421 15 37.5 18.3579 37.5 22.5C37.5 26.6421 34.1421 30 30 30C25.8579 30 22.5 26.6421 22.5 22.5Z",
    fill: "#D2D1CE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13591_6448",
    x: -14,
    y: -10,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13591_6448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13591_6448",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatarImg);
export default __webpack_public_path__ + "static/media/no-avatar-img.732d289bbb8642b664c1ad3fbdec1821.svg";
export { ForwardRef as ReactComponent };